import { fetchData, ENDPOINT_HOST } from './api_helper';

const apiURL = `${ENDPOINT_HOST}dashboards/`;

const fetchAdminDashboard = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/super_admin_dashboard`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchPartnerDashboard = (id, siteId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}/partner_admin_dashboard?site_id=${siteId}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchTimeLine = (id, type, page) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}get_timeline?id=${id}&type=${type}&page=${page}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchWorkerDashboard = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}worker_dashboard`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));
const fetchVivuDashboard = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}vivu_dashboard`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));


export default {
  fetchAdminDashboard,
  fetchPartnerDashboard,
  fetchTimeLine,
  fetchWorkerDashboard,
  fetchVivuDashboard
};



// WEBPACK FOOTER //
// ./src/api/dashboards.js